// firebase
import { getFunctions, httpsCallable } from "firebase/functions";
import { getStorage, ref, listAll } from "firebase/storage";

// jszip
import JSZip from "jszip";

// file-saver
import { saveAs } from "file-saver";

// A ---------------------------------------------------------------------- M

const downloadAsZip = async (uploadID, tagId) => {
  const storage = getStorage();
  const functions = getFunctions();
  const getSignedUrl = httpsCallable(functions, "getSignedDownloadUrl");

  const storageRef = ref(storage, uploadID);

  try {
    // List all files in the folder
    const fileList = await listAll(storageRef);
    const zip = new JSZip();
    const folder = zip.folder(uploadID);

    // Loop through each file and add it to the zip
    const filePromises = fileList.items.map(async (fileRef) => {
      const filePath = fileRef.fullPath;

      const res = await getSignedUrl({ storagePath: filePath, tagId });
      const fileUrl = res.data.url;

      const response = await fetch(fileUrl);
      if (!response.ok) throw new Error(`HTTP ${response.status} for ${filePath}`);

      const fileData = await response.blob();
      folder.file(fileRef.name, fileData);
    });

    // Wait for all files to be added to the zip
    await Promise.all(filePromises);

    // Generate the ZIP file and trigger download
    const zipContent = await zip.generateAsync({ type: "blob" });
    saveAs(zipContent, `${uploadID}.zip`);
  } catch (err) {
    console.error("Error creating ZIP file:", err);
  }
};

export default downloadAsZip;
